import * as React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";

interface IArrowProps {
  variant?: string;
  disabled?: boolean;
  justifyContent?: string;
}

const ButtonLinkStyles = css<IArrowProps>`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[3]};
  border: 0;
  border-radius: 4px;
  font-size: ${({ theme }) => theme.fontSizes[2]};
  background-color: ${({ theme }) => theme.colors.cyan};
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;

  ${(props) =>
    props.variant === "secondary" &&
    css`
      background-color: transparent;
      color: ${({ theme }) => theme.colors.white};
      text-transform: uppercase;
    `}

  ${(props) =>
    props.variant === "tertiary" &&
    css`
      background-color: ${({ theme }) => theme.colors.white4};
      color: ${({ theme }) => theme.colors.white};
      box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.white16};
      &:hover {
        background-color: ${({ theme }) => theme.colors.white8};
      }
    `}

  ${(props) =>
    props.variant === "quaternary" &&
    css`
      background-color: ${({ theme }) => theme.colors.white};
      color: ${({ theme }) => theme.colors.primary};
      &:hover {
        background-color: ${({ theme }) => theme.colors.greyLight};
      }
    `}

  ${(props) =>
    props.justifyContent === "flexStart" &&
    css`
      justify-content: flex-start;
    `}
    ${(props) =>
    props.justifyContent === "flexEnd" &&
    css`
      justify-content: flex-end;
    `}
    ${(props) =>
    props.justifyContent === "center" &&
    css`
      justify-content: center;
    `};

  ${(props) =>
    props.disabled &&
    css`
      background-color: inherit;
      color: ${({ theme }) => theme.colors.white20};
      cursor: auto;

      &:hover {
        background-color: inherit;
        cursor: not-allowed;
      }
    `}
`;

const StyledButtonLink = styled(Link)<IArrowProps>`
  ${ButtonLinkStyles}
`;

export const ButtonLinkCenter = styled.span`
  flex: 1;
  text-align: center;
`;

interface IProps {
  onClick?: () => void;
  to: string;
  children: React.ReactNode;
  variant?: string;
  disabled?: boolean;
  justifyContent?: string;
}

type Props = IProps;

const ButtonLink: React.FC<Props> = ({
  children,
  onClick = undefined,
  to,
  variant = "primary",
  disabled = false,
  justifyContent,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <StyledButtonLink
      to={to}
      onClick={handleClick}
      variant={variant}
      disabled={disabled}
      justifyContent={justifyContent}
    >
      {children}
    </StyledButtonLink>
  );
};

export default ButtonLink;
